import { render, staticRenderFns } from "./SlideItem.vue?vue&type=template&id=0db3f4d4&scoped=true"
import script from "./SlideItem.vue?vue&type=script&lang=js"
export * from "./SlideItem.vue?vue&type=script&lang=js"
import style0 from "./SlideItem.vue?vue&type=style&index=0&id=0db3f4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3f4d4",
  null
  
)

export default component.exports